
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './RegistrationForm.css';
import { Link } from 'react-router-dom';

const RegistrationForm = () => {

  const [registerWith, setRegisterWith] = useState('email'); // 'email' or 'mobile'
  const [form, setForm] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  // Removed old popup states
  const [sidePopup, setSidePopup] = useState(""); // message
  const [sidePopupType, setSidePopupType] = useState(""); // 'success' | 'error'
  // Sync with dark mode from Navbar
  useEffect(() => {
    const syncTheme = () => {
      if (document.body.classList.contains('dark-mode')) {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
      }
    };
    syncTheme();
    window.addEventListener('darkModeChanged', syncTheme);
    return () => window.removeEventListener('darkModeChanged', syncTheme);
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegisterWithChange = (val) => {
    setRegisterWith(val);
    // Clear the other field when switching
    setForm(f => ({ ...f, email: '', mobile: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setSidePopup("");
    setSidePopupType("");
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      setSidePopup("Passwords do not match");
      setSidePopupType("error");
      setTimeout(() => setSidePopup(""), 3500);
      return;
    }
    if (registerWith === "email" && !form.email) {
      setError("Email is required");
      setSidePopup("Email is required");
      setSidePopupType("error");
      setTimeout(() => setSidePopup(""), 3500);
      return;
    }
    if (registerWith === "mobile" && !form.mobile) {
      setError("Mobile number is required");
      setSidePopup("Mobile number is required");
      setSidePopupType("error");
      setTimeout(() => setSidePopup(""), 3500);
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const payload = {
        name: form.name,
        password: form.password,
        role: "user" // Set role as user
      };
      if (registerWith === "email") payload.email = form.email;
      if (registerWith === "mobile") payload.mobile = form.mobile;
      // apiUrl already ends with /api
      const res = await axios.post(`${apiUrl}/publicuser/register`, payload);
      setSuccess(res.data.message || "Registration successful!");
      setSidePopup(res.data.message || "Registration successful!");
      setSidePopupType("success");
      setTimeout(() => setSidePopup(""), 3500);
    } catch (err) {
      const msg = err.response?.data?.error || "Registration failed";
      setError(msg);
      setSidePopup(msg);
      setSidePopupType("error");
      setTimeout(() => setSidePopup(""), 3500);
    }
  };

  return (
    <div className="public-registration-form-container">
      {/* Side Popup Message - always above all content */}
      {sidePopup && (
        <div
          style={{
            position: "fixed",
            top: 30,
            right: 30,
            minWidth: 250,
            zIndex: 99999,
            background: sidePopupType === "success" ? "#4BB543" : "#e74c3c",
            color: "#fff",
            padding: "16px 28px",
            borderRadius: 8,
            boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
            fontSize: 16,
            fontWeight: 500,
            letterSpacing: 0.2,
            transition: "all 0.3s"
          }}
        >
          {sidePopup}
        </div>
      )}
      <form className="public-registration-form" onSubmit={handleSubmit} autoComplete="off">
        <h2>Register</h2>
        <div className="public-registration-toggle-group">
          <span className="public-registration-toggle-label">Register with:</span>
          <button
            type="button"
            className={`public-registration-toggle-btn${registerWith === 'email' ? ' selected' : ''}`}
            onClick={() => handleRegisterWithChange('email')}
            tabIndex={0}
          >
            Email
          </button>
          <button
            type="button"
            className={`public-registration-toggle-btn${registerWith === 'mobile' ? ' selected' : ''}`}
            onClick={() => handleRegisterWithChange('mobile')}
            tabIndex={0}
          >
            Mobile
          </button>
        </div>
        <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required className="public-registration-input" />
        {registerWith === 'email' && (
          <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required className="public-registration-input" />
        )}
        {registerWith === 'mobile' && (
          <input name="mobile" type="tel" placeholder="Mobile Number" value={form.mobile} onChange={handleChange} pattern="[0-9]{10}" maxLength={10} minLength={10} required className="public-registration-input" />
        )}
        <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required className="public-registration-input" />
        <input name="confirmPassword" type="password" placeholder="Confirm Password" value={form.confirmPassword} onChange={handleChange} required className="public-registration-input" />
        <button type="submit" className="public-registration-submit">Register</button>
        {error && <div className="public-registration-error">{error}</div>}
        {success && <div className="public-registration-success">{success}</div>}

        <div className="public-registration-form-link-container" style={{ textAlign: 'center', marginTop: '0.5rem' }}>
          <span>Already have an account?{' '}
            <Link to="/publicuser/login" className="public-registration-form-link">Login here</Link>
          </span>
        </div>
      </form>
    </div>
  );
};

export default RegistrationForm;
